import Column from '@components/Column';
import Row from '@components/Row';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Link } from '@stackflow/link';
import { useTranslation } from 'react-i18next';

import useTier from './hooks/useTier';
import TierCount from './TierCount';
import TierGrade from './TierGrade';
import TierProgress from './TierProgress';

function TierInfo() {
    const { t } = useTranslation('tier');

    const { data, isSuccess } = useTier();
    if (isSuccess && data) {
        return (
            <Container>
                <Column fullWidth spacing={10}>
                    <TierGrade data={data}/>
                    <TierCount data={data} />
                    <TierProgress data={data} />
                </Column>
                <Row fullWidth spacing={8}>
                    <Link activityName='TierBenefitsBottomSheet'
                        activityParams={{}}
                        css={css`flex: 1`} >
                        <Button>{t('tierInfo.viewBenefits')}</Button>
                    </Link>
                    <Link activityName='TierHistoryActivity'
                        activityParams={{}}
                        css={css`flex: 1`} >
                        <Button>{t('tierInfo.viewAchievement')}</Button>
                    </Link>
                </Row>
            </Container>
        );
    }
    return null;
}

const Container = styled.div`
    background-color: var(--color-gray1);
    border-radius: 12px;
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 100%;
`;

const Button = styled.button`
    flex: 1;
    padding: 8px 0;
    border-radius: 20px;
    border: 1px solid var(--color-gray2);
    background-color: var(--color-gray0);
    color: var(--color-gray6);
`;

export default TierInfo;
